import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { UnsoldDescriptionService } from '../../../services/index';

@Component({
    selector: 'add-edit-unsold-description',
    templateUrl: './addEditUnsoldDescription.component.html'
})
export class AddEditUnsoldDescriptionComponent implements OnInit {

    @Output() unsoldDescriptionLoadEvent = new EventEmitter();

    public title: string;
    public unsoldDescriptionData: any = {};
    public isLoading: boolean = false;

    statusOptions = ['Active', 'Inactive'];

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private unsoldDescriptionService: UnsoldDescriptionService
    ) { }

    ngOnInit(): void {
        if (this.unsoldDescriptionData.mode === 'Add') {
            this.unsoldDescriptionData.status = 'Active';
        }
    }

    onSave(): void {
        this.isLoading = true;

        let params = {
            mode: this.unsoldDescriptionData.mode,
            name: this.unsoldDescriptionData.name,
            status: this.unsoldDescriptionData.status
        };

        if (this.unsoldDescriptionData.mode === 'Edit') {
            params['id'] = this.unsoldDescriptionData.id;
        }

        this.unsoldDescriptionService
            .addUpdateUnsoldDescription(params)
            .then((res: any) => {
                this.isLoading = false;
                if (res && res.success) {
                    this.toasterService.pop({
                        type: 'success',
                        title: 'Success',
                        body: res.message
                    });
                    this.unsoldDescriptionLoadEvent.emit();
                    this.bsModalRef.hide();
                } else {
                    this.toasterService.pop({
                        type: 'error',
                        title: 'Error',
                        body: res.message || 'Something went wrong'
                    });
                }
            })
            .catch(() => {
                this.isLoading = false;
                this.toasterService.pop({
                    type: 'error',
                    title: 'Error',
                    body: 'Something went wrong'
                });
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/unsoldDescription/addEditUnsoldDescription.component.ts